import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/apiService";
import { Plus, X } from "lucide-react";

const NewAlbum = () => {
  const navigate = useNavigate();
  const [album, setAlbum] = useState({
    category: "",
    description: "",
    name: "",
    cover: null,
    images: [],
    rfid: "",
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [previewCover, setPreviewCover] = useState(null);
  const [previewImages, setPreviewImages] = useState([]);
  const [chapters, setChapters] = useState([]);

  useEffect(() => {
    fetchChapters();
  }, []);

  const fetchChapters = async () => {
    try {
      const response = await apiService.postData("admin/chapter-list", {});
      if (!response.error) {
        setChapters(response.data.rows);
      }
    } catch (error) {
      console.error("Error fetching chapters:", error);
    }
  };

  const handleChange = (e) => {
    const { name, type, files, value } = e.target;

    if (type === "file") {
      if (name === "cover") {
        const file = files[0];
        setAlbum({ ...album, cover: file });
        setPreviewCover(URL.createObjectURL(file));
      } else if (name === "images") {
        const filesArray = Array.from(files);
        setAlbum({ ...album, images: filesArray });
        setPreviewImages(filesArray.map((file) => URL.createObjectURL(file)));
      }
    } else {
      setAlbum({ ...album, [name]: value });
    }
  };

  const removeCover = () => {
    setAlbum({ ...album, cover: null });
    setPreviewCover(null);
  };

  const removeImage = (index) => {
    const newImages = album.images.filter((_, i) => i !== index);
    setAlbum({ ...album, images: newImages });
    setPreviewImages(previewImages.filter((_, i) => i !== index));
  };

  const handleChapterSelect = (chapter) => {
    setSelectedChapters((prev) =>
      prev.some((c) => c.chapter_id === chapter.chapter_id)
        ? prev.filter((c) => c.chapter_id !== chapter.chapter_id)
        : [...prev, chapter]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("category", album.category);
    formData.append("description", album.description);
    formData.append("name", album.name);
    formData.append("rfid", album.rfid);
    if (album.cover) formData.append("cover", album.cover);
    album.images.forEach((image) => formData.append("image", image));
    formData.append("chapters", JSON.stringify(selectedChapters));

    try {
      const response = await apiService.postData(
        "admin/save-album",
        formData,
        true
      );
      if (!response.error) {
        console.log("Album saved successfully", response.data);
        navigate("/album");
      }
    } catch (error) {
      console.error("Error saving album:", error);
    }
  };

  return (
    <div className="col-md-12 mt-4">
      <div className="card">
        <div className="card-header">
          <h4>New Album</h4>
        </div>
        <div className="card-body">
          <div className="">
            <form onSubmit={handleSubmit} className="">
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Category</label>
                  <input
                    type="text"
                    name="category"
                    className="form-control"
                    value={album.category}
                    onChange={handleChange}
                    placeholder="Enter Category"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={album.name}
                    onChange={handleChange}
                    placeholder="Enter Name"
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Cover Image</label>
                  <input
                    type="file"
                    name="cover"
                    className="form-control"
                    onChange={handleChange}
                  />
                  {previewCover && (
                    <div className="mt-2 position-relative">
                      <img
                        src={previewCover}
                        alt="Cover"
                        className="img-thumbnail"
                        style={{ width: "100px", height: "100px" }}
                      />
                      <button
                        type="button"
                        className="btn btn-danger btn-sm position-absolute top-0 end-0"
                        onClick={() => setPreviewCover(null)}
                      >
                        <X size={12} />
                      </button>
                    </div>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">Images</label>
                  <input
                    type="file"
                    name="images"
                    className="form-control"
                    multiple
                    onChange={handleChange}
                  />
                  <div className="d-flex mt-2">
                    {previewImages.map((img, index) => (
                      <div key={index} className="position-relative me-2">
                        <img
                          src={img}
                          alt="Preview"
                          className="img-thumbnail"
                          style={{ width: "100px", height: "100px" }}
                        />
                        <button
                          type="button"
                          className="btn btn-danger btn-sm position-absolute top-0 end-0"
                          onClick={() =>
                            setPreviewImages(
                              previewImages.filter((_, i) => i !== index)
                            )
                          }
                        >
                          <X size={12} />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  name="description"
                  className="form-control"
                  value={album.description}
                  onChange={handleChange}
                  placeholder="Enter Description"
                ></textarea>
              </div>

              <div className="mb-3">
                <label className="form-label">RFID</label>
                <input
                  type="text"
                  name="rfid"
                  className="form-control"
                  value={album.rfid}
                  onChange={handleChange}
                  placeholder="Enter RFID"
                />
              </div>

              <div>


              <button
                type="button"
                className="btn btn-warning d-flex gap-2 mt-2"
                onClick={() => setIsModalOpen(true)}
              >
                <Plus size={16} /> Select Chapters
              </button>
              <button type="submit" className="btn btn-primary mt-3">
                <Plus size={16} /> Add Album
              </button>
              </div>
              {selectedChapters.length > 0 && (
                <table className="table table-striped mt-3">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Audio</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedChapters.map((chapter) => (
                      <tr key={chapter.chapter_id}>
                        <td>{chapter.title}</td>
                        <td>{chapter.description}</td>
                        <td>
                          {chapter.audio_file ? (
                            <audio controls>
                              <source
                                src={chapter.audio_file}
                                type="audio/mpeg"
                              />
                            </audio>
                          ) : (
                            "No Audio"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {isModalOpen && (
                <div className="modal show d-block">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Select Chapters</h5>
                        <button
                          type="button"
                          className="close"
                          onClick={() => setIsModalOpen(false)}
                        >
                          &times;
                        </button>
                      </div>
                      <div className="modal-body">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Select</th>
                              <th>Title</th>
                              <th>Description</th>
                            </tr>
                          </thead>
                          <tbody>
                            {chapters.map((chapter) => (
                              <tr key={chapter.chapter_id}>
                                <td>
                                  <input
                                    type="checkbox"
                                    onChange={() =>
                                      handleChapterSelect(chapter)
                                    }
                                  />
                                </td>
                                <td>{chapter.title}</td>
                                <td>{chapter.description}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewAlbum;
